export const STORE_COMPETITOR_INVENTORIES = 'competitorInventories';
export const COM_SET_DEFAULT_INVENTORY_FILTERS = 'inventorySetDefaultFilters';
export const COM_GET_INVENTORIES_DATA = 'getInventorydata';
export const COM_INVENTORY_DOWNLOAD_FILE = 'exportInventoryFile';
